import { reduxKey } from './constants';
import { createSelector } from 'reselect';
function getState(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
export const getUserGiftState = createSelector([
    getState,
    (_, useridUuid)=>useridUuid
], (state, useridUuid)=>{
    var _state_useridUuid;
    return (_state_useridUuid = state[useridUuid]) !== null && _state_useridUuid !== void 0 ? _state_useridUuid : {};
});

//# sourceMappingURL=selectors.js.map